import { $ } from "../shared/globals.js";

export function createAppContext() {
    const $html = $("html");
    const $body = $("body");
    const $navbar = $(".navbar");
    const $menuButton = $(".menu-button");
    const $mainBrandBox = $(".main-brand-box");
    const $subpageScene = $(".main-scene.subpage-scene").first();
    const $mainScene = $subpageScene.length ? $subpageScene : $(".main-scene").first();
    const sceneImageClassPrefix = $mainScene.hasClass("subpage-scene") ? "img-s-" : "img-f-";
    const sceneImageClasses = ["01", "02", "03", "04", "05", "06"].map((num) => `${sceneImageClassPrefix}${num}`);

    const $heroTiger = $mainScene.find(".hero-tiger");
    const $tigerText = $mainScene.find(".tiger-text-animate");
    const $floatingImgs = $mainScene.find(".hero-floating-img");
    const $sectionFloatingImgs = $(".section-floating-img");
    const $expandingImg = $mainScene.find("#hero-expanding-img");
    const $img01 = $mainScene.find(`.hero-floating-img.${sceneImageClassPrefix}01`);
    const $img03 = $mainScene.find(`.hero-floating-img.${sceneImageClassPrefix}03`);
    const $img04 = $mainScene.find(`.hero-floating-img.${sceneImageClassPrefix}04`);
    const $img05 = $mainScene.find(`.hero-floating-img.${sceneImageClassPrefix}05`);
    const $img06 = $mainScene.find(`.hero-floating-img.${sceneImageClassPrefix}06`);
    const $backgroundImgs = $floatingImgs.not("#hero-expanding-img");
    const $parallaxImgs = $backgroundImgs.add($sectionFloatingImgs);

    const $sliderMobile = $mainScene.find(".slider-mobile");
    const $tigerTextMobile = $mainScene.find(".tiger-text-animate-mobile");

    const $gridScrollScene = $(".section.grid-scroll-scene");
    const $gridTopTextPath = $(".section-text-scroll.top-text-scroll").find("textPath");
    const $gridBottomTextPath = $(".section-text-scroll.bottom-text-scroll").find("textPath");
    const $gridScrollTiger = $gridScrollScene.find(".grid-scroll-tiger-walk");
    const $gridScrollTigerStatic = $gridScrollTiger.find(".event-tiger-static");
    const $gridScrollTigerFrames = $gridScrollTiger.find(".event-tiger-frame");
    const gridImageClasses = [
        "img-f-01",
        "img-f-02",
        "img-f-03",
        "img-f-04",
        "img-s-01",
        "img-s-02",
        "img-s-03",
        "img-s-04",
    ];

    const $tigerFrames = $(".tiger-frame");
    const $tigerStatic = $(".tiger-static");

    return {
        $html,
        $body,
        $navbar,
        $menuButton,
        $mainBrandBox,
        $mainScene,
        sceneImageClassPrefix,
        sceneImageClasses,
        $heroTiger,
        $tigerText,
        $floatingImgs,
        $sectionFloatingImgs,
        $expandingImg,
        $img01,
        $img03,
        $img04,
        $img05,
        $img06,
        $backgroundImgs,
        $parallaxImgs,
        $sliderMobile,
        $tigerTextMobile,
        $gridScrollScene,
        $gridTopTextPath,
        $gridBottomTextPath,
        $gridScrollTiger,
        $gridScrollTigerStatic,
        $gridScrollTigerFrames,
        gridImageClasses,
        $tigerFrames,
        $tigerStatic,
    };
}
